"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSalaryUnit = exports.SALARY_UNITS_BY_COUNTRY = exports.SALARY_UNITS = void 0;
const lib_custom_types_1 = require("@backend/lib-custom-types");
exports.SALARY_UNITS = (0, lib_custom_types_1.strictUnionArray)()(['HOURLY', 'MONTHLY', 'YEARLY']);
exports.SALARY_UNITS_BY_COUNTRY = {
    FR: exports.SALARY_UNITS,
    IT: exports.SALARY_UNITS,
    US: ['HOURLY', 'YEARLY'],
};
const isSalaryUnit = (value) => (0, lib_custom_types_1.includes)(exports.SALARY_UNITS, value);
exports.isSalaryUnit = isSalaryUnit;
